module.exports = ".wrapper-image {\n  width: 150px; }\n  .wrapper-image img.ng-star-inserted {\n    width: 100%; }\n"